import script from "./viewDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./viewDetails.vue?vue&type=script&lang=ts&setup=true"

import "./viewDetails.vue?vue&type=style&index=0&id=7e893866&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e893866"]])

export default __exports__